import { useMemo, useState } from "react";
import { PiggyBank } from "lucide-react";
import { ToolLayout, TwoCol } from "@/components/tools/ToolLayout";
import { SectionCard, Field, MoneyInput, SliderRow, StatCard, InfoRow, compactINR } from "@/components/tools/kit";
import { GrowthArea } from "@/components/tools/charts";
import { ppf } from "@/lib/calculators";

export default function Ppf() {
  const [yearlyDeposit, setYearly] = useState(150000);
  const [rate, setRate] = useState(7.1);
  const [years, setYears] = useState(15);
  const r = useMemo(() => ppf({ yearlyDeposit, rate, years }), [yearlyDeposit, rate, years]);
  const chart = r.rows.map((x) => ({ year: x.year, value: x.value, invested: x.invested }));
  return (
    <ToolLayout title="PPF Calculator" subtitle="Tax-free, government-backed 15-year compounding" icon={PiggyBank} accent="#2A6F7F">
      <TwoCol
        left={
          <SectionCard title="Your PPF">
            <div className="space-y-5">
              <Field label="Yearly deposit (max ₹1.5L)"><MoneyInput testid="ppf-deposit" value={yearlyDeposit} onChange={(v) => setYearly(Math.min(150000, v))} helper={compactINR(yearlyDeposit) + " / year"} /></Field>
              <Field label="Interest rate (p.a.)" hint={rate + "%"}><SliderRow testid="ppf-rate" value={rate} min={6} max={9} step={0.1} suffix="%" onChange={setRate} /></Field>
              <Field label="Tenure" hint={years + " yrs"}><SliderRow testid="ppf-years" value={years} min={15} max={50} suffix=" yr" onChange={setYears} /></Field>
              <p className="text-xs text-[#8A9790]">Current PPF rate is 7.1% p.a. Tenure is 15 years, extendable in 5-year blocks.</p>
            </div>
          </SectionCard>
        }
        right={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <StatCard testid="ppf-invested" label="Total Invested" value={compactINR(r.invested)} accent="#2A6F7F" />
              <StatCard testid="ppf-interest" label="Interest Earned" value={compactINR(r.interest)} accent="#D99B26" />
              <StatCard testid="ppf-maturity" label="Maturity Value" value={compactINR(r.maturity)} accent="#2D6A4F" big />
            </div>
            <SectionCard title="Balance growth"><GrowthArea data={chart} keys={[{ key: "value", name: "Balance", color: "#2A6F7F" }, { key: "invested", name: "Invested", color: "#D99B26" }]} /></SectionCard>
          </>
        }
      />
    </ToolLayout>
  );
}
